export class MyProjectResponse{
  projectId : string;
  name : string;
  isSelected : boolean;
  country : string;
  currency : string;
  roleId : number;
  owner : boolean;
  type : string;
  statusOnboarding : string;
  paymentBlockStatus : string | null;
  planId?: number | null;
  paymentBalanceType?: string | null;
  isAdditionalProject: boolean;
  stripeCustomerId?: string | null;
  stripeCustomerName?: string | null;
  hubspotRecordId?: string | null;
  hubspotRecordName?: string | null;
}

export class UpdateProjectNameRequest{
  projectId : string;
  name : string;
}


export class SelectProjectRequest{
  projectId : string;
}

export enum PaymentBalanceType {
  MONO_INTERFACE_BALANCE_TYPE = 'M',
  CALCULATED_TYPE = 'C',
  OVERRIDED_TYPE = 'O',
  NOT_SPECIFIED_BALANCE_TYPE = '?'
}